export default __webpack_public_path__ + "static/media/fluffys_fortune.861a24e2.jpeg";